import { render, staticRenderFns } from "./baseTaskCard.vue?vue&type=template&id=1d3a95b6&"
import script from "./baseTaskCard.vue?vue&type=script&lang=js&"
export * from "./baseTaskCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports